import type { IPaginationBar } from '../../../types/data_table';

import { Pagination } from '../../ContentSwitchers/Pagination';
import { SkeletonBase } from '../../SkeletonLoader/SkeletonBase';

import styles from './pagination-bar.module.scss';

/**
 * The pager below a `DataTable`.
 *
 * It stays mounted while the table is fetching and shows a skeleton in place
 * of the controls, so the page does not jump every time the rows are replaced.
 * `isMobile` is a data attribute rather than a media query because the table
 * can be narrow inside a wide viewport.
 */
export const PaginationBar = (props: IPaginationBar) => (
  <div
    data-pagination-bar-is-mobile={props.isMobile}
    className={styles['pagination-bar']}
  >
    {props.isLoading ? (
      <SkeletonBase height="2.5rem" />
    ) : (
      <Pagination {...props} />
    )}
  </div>
);
